// import '../css/app.scss'
// let's not do this. avoids flash of unstyled content.
// see the head tag for how we are loading this css

import './components/new-navigation.js';
import './components/search.js';
import './components/sticky.js';

// import './components/nav-widget.js';

/// Oembed, embedly, video, etc.
document.querySelectorAll( 'oembed[url]' ).forEach( element => {
    // Create the <a href="..." class="embedly-card"></a> element that Embedly uses
    // to discover the media.
    const anchor = document.createElement( 'a' );

    anchor.setAttribute( 'href', element.getAttribute( 'url' ) );
    anchor.className = 'embedly-card';

    element.appendChild( anchor );

    embedly("defaults", {
        cards: {
          width: 980,
          align: 'left',
          chrome: 0
        }
      });
} );

if (document.getElementById('post-a-job')) {
    import("./components/ckeditor-mdhs.js");
}

if (document.getElementById('scholarships-app')) {
    import("./components/scholarships.js");
}


if (document.getElementById('get-list')) {
    // test
    var testButton = document.getElementById('get-list');
    // click
    testButton.addEventListener('click', function() {
        // fetch
        fetch('/actions/_mad-utilities/chimp/get-lists')
            .then(data => {
                console.log(data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
}

if (document.getElementById('scholarships')) {
    
    var select = document.getElementById('scholarships');
    select.addEventListener('change', function() {
            var url = select.value;
            window.location.href = url;
    });
}

const chimpForms = [
    {
        formId: 'chimp',
        emailId: 'chimp-email',
        submitId: 'chimp-submit',
        successId: 'chimp-success',
        errorId: 'chimp-error'
    },
    {
        formId: 'chimp-c4npr',
        emailId: 'chimp-email-c4npr',
        submitId: 'chimp-submit-c4npr',
        successId: 'chimp-success-c4npr',
        errorId: 'chimp-error-c4npr'
    },
    {
        formId: 'chimp-c4npr-segundo',
        emailId: 'chimp-email-c4npr-segundo',
        submitId: 'chimp-submit-c4npr-segundo',
        successId: 'chimp-success-c4npr-segundo',
        errorId: 'chimp-error-c4npr-segundo'
    }
];

chimpForms.forEach(cfg => {
    const form = document.getElementById(cfg.formId);
    if (!form) return;

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const object = {};
        formData.forEach((value, key) => {
            object[key] = value;
        });
        const data = JSON.stringify(object);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/actions/_mad-utilities/chimp/subscribe-to-list', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(data);

        xhr.onload = function () {
            const input = document.getElementById(cfg.emailId);
            const submitButton = document.getElementById(cfg.submitId);
            const chimpSuccess = document.getElementById(cfg.successId);
            const chimpError = document.getElementById(cfg.errorId);

            let response;
            try {
                response = JSON.parse(xhr.responseText);
            } catch {
                response = { success: false };
            }

            // return console.log(response);

            if (response.success !== true) {
                // append the error message to the content of the chimpError element               
                chimpError.textContent += response.error;
                chimpError.classList.remove('hidden');

                submitButton.classList.add('hidden');
                input.classList.add('hidden');
                setTimeout(() => {
                    submitButton.classList.remove('hidden');
                    input.classList.remove('hidden');
                    chimpError.classList.add('hidden');
                }, 5000);
                return;
            }

            input.value = '';
            chimpSuccess.classList.remove('hidden');
            submitButton.classList.add('hidden');
            input.classList.add('hidden');
            setTimeout(() => {
                chimpSuccess.classList.add('hidden');
                input.classList.remove('hidden');
                submitButton.classList.remove('hidden');
            }, 5000);
        };
    });
});

// batch
if (document.getElementById('blast')) {
    // do something
    var blastButton = document.getElementById('blast');
    // click
    blastButton.addEventListener('click', function(event) {
        event.preventDefault();

        var data = {
            foo: "bar"
        };
    
        var tokenName = window.csrfTokenName;
        data[ tokenName ] = window.csrfTokenValue;
        
        // build the request and send it
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/actions/_mad-utilities/postmark/do-something', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(data));

        // do something with the response
        xhr.onload = function () {
            console.log( xhr.responseText );
        };


    });

}

// on document load
document.addEventListener('DOMContentLoaded', function() {

    console.log('document loaded');

});







